import React from "react"
import AboutLiveLifeV1 from "./AboutLiveLifeV1"
import AboutLiveLifeV2 from "./AboutLiveLifeV2"

function AboutLiveLife({ currentUser }) {
  const isV2 = String(currentUser?.active_enrolment?.live_life_version) === "2"
  return isV2 ? <AboutLiveLifeV2 /> : <AboutLiveLifeV1 />
}

export default AboutLiveLife
